import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { Field } from 'redux-form';
import { Link } from 'react-router-dom';

// Components
import { ButtonBlock, ContinueButton } from 'styles/common';

// Styles & Images
import { AlertBlock, LoginCommonWrapper, MainText } from './styles';
import { InputField } from 'components/Fields';
import CloseBtn from 'assets/images/close-button.png';
import { hourglassImage } from 'src/views/practitioner/services/svgImages';

export class LoginView extends Component {
  constructor() {
    super();
    this.state = { passwordView: false };
  }

  render() {
    const { passwordView } = this.state;
    const { auth, i18n, mainText, handleSubmit, isPatient } = this.props;
    return (
      <LoginCommonWrapper>
        {/* ──── Error Blocks ─────────────────────────────────────────────────────────────── */}

        {(auth.isTokenExpired && (
          <AlertBlock expired>
            {hourglassImage()}
            <p>{i18n.t('session_expired_text')}</p>
          </AlertBlock>
        )) || <MainText>{mainText}</MainText>}

        {i18n.t(auth.statusText) && (
          <AlertBlock>
            <img src={CloseBtn} alt="close"/>
            <p>{i18n.t(auth.statusText)}</p>
          </AlertBlock>
        )}

        {/* ──── Form ────────────────────────────────────────────────────────────────────── */}

        <form onSubmit={handleSubmit} noValidate>
          {/* email */}
          <Field
            style={{ marginBottom: '31px' }}
            type="email"
            component={InputField}
            name="email"
            commonError={auth.statusText}
            placeholder={i18n.t('email')}
            label={i18n.t('email')}
            max={100}
          />

          {/* password */}
          <Field
            type={passwordView ? 'text' : 'password'}
            password={{
              isForgot: false,
              isView: passwordView,
              show: () => {
                this.setState({ passwordView: !this.state.passwordView });
              }
            }}
            max={32}
            component={InputField}
            commonError={auth.statusText}
            name="password"
            label={i18n.t('password')}
            placeholder={i18n.t('password')}
          />

          {isPatient && <Link to="restore-access">{i18n.t('forgot_password')}</Link>}

          <ButtonBlock>
            <ContinueButton style={{ padding: '0.806em 5.381em' }} type="submit">
              {i18n.t('login')}
            </ContinueButton>
          </ButtonBlock>
        </form>

        {this.props.children}
      </LoginCommonWrapper>
    );
  }
}

export default withTheme(LoginView);
